<template>
  <div class="row">
    <div class="col-sm-6">
      <base-field label="First Name" mandatory>
        <base-input
          v-model="value.profile.firstName"
          :personal="registering"
          placeholder="first name"
          required />
      </base-field>
      <base-field label="Last Name" mandatory>
        <base-input
          v-model="value.profile.lastName"
          :personal="registering"
          placeholder="last name"
          required />
      </base-field>
      <base-field label="Company Name" mandatory>
        <base-input v-model="value.profile.companyName" placeholder="company name" required />
      </base-field>
      <base-field label="Company Number" mandatory>
        <base-input v-model="value.profile.companyNumber" placeholder="company number" required />
      </base-field>
      <base-field label="Country of Incorporation" mandatory>
        <base-select v-model="value.profile.incorporationCountry" placeholder="country" required source="countries" />
      </base-field>
      <base-field addon-right-icon="calendar-alt" label="Date of Incorporation" mandatory>
        <base-input v-model="value.profile.incorporationDate" datepicker placeholder="date of incorporation" required />
      </base-field>
      <base-field v-if="!registering" label="Email Address" mandatory>
        <base-input v-model="value.email" placeholder="email" required type="email" />
      </base-field>
      <base-field v-if="$auth.admin() && changeRole" label="Role" mandatory>
        <base-select v-model="value.role" :model="roles" placeholder="role" required />
      </base-field>
    </div>
    <div class="col-sm-6">
      <base-field addon-left-icon="calendar-alt" label="Date of Birth" mandatory>
        <base-input
          v-model="value.profile.dob"
          :datepicker="{ defaultDate: maxDate, maxDate }"
          :personal="registering"
          placeholder="date of birth"
          required />
      </base-field>
      <base-field label="Phone Number" mandatory>
        <base-input v-model="value.profile.phone" placeholder="phone number" required type="tel" />
      </base-field>
      <base-field label="Website">
        <base-input v-model="value.profile.website" placeholder="website" type="url" />
      </base-field>
      <base-field label="VAT Number">
        <base-input v-model="value.profile.vat" placeholder="vat number" />
      </base-field>
      <address-finder v-model="value.profile.address" />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

import AddressFinder from './AddressFinder.vue'

export default {
  created () {
    this.$store.dispatch('core/roles/all')
  },

  name: 'CompanyDetails',

  components: {
    AddressFinder
  },

  props: {
    changeRole: Boolean,
    registering: Boolean,
    value: { required: true, type: Object }
  },

  computed: {
    maxDate () {
      const year = this.$moment().year()

      // Start date from 18 years ago.
      return this.$moment().year(year - 18).toDate()
    },

    ...mapState({
      roles: store => store.core.roles.all
    })
  }
}
</script>
